/**
 * Types and constants for the Data API client
 * This file contains no server-side imports and can be used in client components
 */

// Supported dataset types
export type DatasetType =
  | "morningstar_funds"
  | "morningstar_category"
  | "morningstar_etf"
  | "morningstar_index"
  | "twelve"
  | "eodhd"
  | "custom"
  | "combined";

export type InstrumentSearchResult = {
  ticker: string;
  name: string;
  isin: string;
  performanceId?: string;
  categoryId?: string;
  currency?: string;
  exchange?: string;
  inceptionDate?: string;
};

export type InstrumentMetadata = {
  ticker: string;
  name: string;
  isin?: string;
  currency?: string;
  firstdate: string | null; // YYYY-MM-DD format or null if no data
  lastdate: string | null; // YYYY-MM-DD format or null if no data
  // QP-179 — SFDR + the two Morningstar ESG sector maps. `eusfdrType` is
  // flattened to the top level; the two maps survive the flatten intact.
  eusfdrType?: 6 | 8 | 9;
  esgExclusions?: Record<string, boolean>;
  esgInvolvement?: Record<string, boolean>;
  [key: string]: any; // Additional metadata fields
};

/**
 * Available datasets for instrument search
 */
export const AVAILABLE_DATASETS = [
  {
    id: "morningstar_funds",
    name: "Morningstar Funds",
    description: "Mutual funds from Morningstar database",
  },
  {
    id: "morningstar_category",
    name: "Morningstar Categories",
    description: "Fund categories from Morningstar",
  },
  {
    id: "morningstar_etf",
    name: "Morningstar ETFs",
    description: "ETFs from Morningstar database",
  },
  {
    id: "morningstar_index",
    name: "Morningstar Indexes",
    description: "Market indexes from Morningstar",
  },
  {
    id: "twelve",
    name: "Twelve Data",
    description: "Stocks, forex, and crypto from Twelve Data",
  },
  {
    id: "eodhd",
    name: "EODHD",
    description: "Global stocks, ETFs, and funds from EODHD",
  },
  {
    id: "custom",
    name: "Custom Instruments",
    description: "Custom instruments",
  },
  {
    id: "combined",
    name: "Combined Instruments",
    description: "Instruments generated by combining different combinations of other instruments",
  },
] as const;
